import { render, staticRenderFns } from "./DetaiCampusAvantage2.vue?vue&type=template&id=64345de2"
import script from "./DetaiCampusAvantage2.vue?vue&type=script&lang=js"
export * from "./DetaiCampusAvantage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports